<!--师资培训任务-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="80px">
                    <el-row class="mt10">
                        <el-col :span="6" class="mb0">
                            <el-form-item label="培训状态" >
                                <el-select clearable @change="pageTeacherTrain(null)" v-model="queryParams.status" placeholder="请选择培训状态">
                                    <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="培训类型" >
                                <el-select clearable @change="pageTeacherTrain(null)" v-model="queryParams.classify" placeholder="请选择培训状态">
                                    <el-option v-for="item in courseClassifyList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item label="培训形式" >
                                <el-select clearable @change="pageTeacherTrain(null)" v-model="queryParams.type" placeholder="请选择培训状态">
                                    <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mb0">
                            <el-form-item >
                                <el-input v-model="queryParams.title" placeholder="请输入名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="pageTeacherTrain(null)" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewLesson(item)">
                                    <div class="course-name">{{item.title}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100"  :src="item.coverUrl" alt/>
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">
                                                <div class="status-info" v-if="item.status===0">初始</div>
                                                <div class="status-info" v-if="item.status===1">进行中</div>
                                                <div class="status-info-fb" v-if="item.status===2">已结束</div>
                                            </div>
                                            <div class="course-commend">培训类型:{{item.classifyName}}</div>
                                            <div class="course-commend">培训形式:
                                                <span v-if="item.type === 0">直播直播</span>
                                                <span v-if="item.type === 1">录播培训</span>
                                                <span v-if="item.type === 2">现场培训</span>
                                                <span v-if="item.type === 3">录播培训</span>
                                            </div>
                                            <div class="course-commend">培训性质:
                                                <span v-if="item.trainNature === '1'">普通</span>
                                                <span v-if="item.trainNature === '2'">名师工作室</span>
                                                <span v-if="item.trainNature === '3'">名校长工作室</span>
                                                <span v-if="item.trainNature === '4'">群组培训</span>
                                            </div>
<!--                                            <div class="course-commend">培训级别:{{ timestampToTime(item.rateEndTime)}}</div>-->
                                        </div>
                                    </div>
                                    <div class="course-time">任务时段:{{ timestampToTime(item.beginTime)}}至{{ timestampToTime(item.endTime)}}</div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageTeacherTrain" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <tea-train-info :train-id="this.lessonId"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import courseInfo from "@/components/course/courseInfo.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import teaTrainInfo from "@/components/teaTrain/teaTrainInfo.vue";
import {trainPageTrain} from "@/api/admin/train";

export default {
    name:'pageCourse',
    components:{teaTrainInfo, pageTag, dataEmpty,courseInfo},
    props:{
        title:{
            type: String,
            default:null
        },
        courseType:{
            type: String,
            default:null
        },
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageTeacherTrain();
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        this.getQueryDict();
        this.pageTeacherTrain();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            itemName:'',
            itemKey:'',
            queryParams: {
                status: '',
                title: '',
                type:'',
                classify:'',
                userIsJoin:'',
                pageNum: 1,
                pageSize: 6,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            lessonId:'',
            periodList: [],
            gradeList: [],
            subjectList: [],
            statusList: [
                { name: '初始', value: 0 },
                { name: '进行中', value: 1 },
                { name: '已结束', value: 2 },
            ],
            joinStatusList: [
                { name: '全部', value: 1 },
                { name: '我参与的', value: 2 },
            ],
            typeList: [
                { name: '现场培训', value: 2 },
                { name: '直播培训', value: 0 },
                { name: '录播培训', value: 1 },
            ],
            natureList: [],
            courseClassifyList: [],
        }
    },
    methods: {
        getQueryDict() {
            // queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
            //     this.periodList = res.data.data;
            // })
            // queryDict({ code: 'activity_nature' }).then(res => {
            //     this.natureList = res.data.data;
            // })
            queryDict({ code: 'train_classify' }).then(res => {
                this.courseClassifyList = res.data.data;
            })
        },
        pageTeacherTrain(){
            trainPageTrain(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;
            });
        },
        viewLesson(item){
            this.showMode = "detail"
            this.lessonId = item.trainId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    border-radius: 28px;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.form-box{
    width: 100%;
    height: 70px;
    flex-shrink: 0;
    margin: auto;
    border-bottom: 2px solid #ff7f2e;
    background-color: #fff;
    padding: 10px 20px 10px 10px;
    box-sizing: border-box;
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
}
.right-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
}
.page-info-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #fff;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #ff7f2e;
}

.info-list-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin: auto;
    overflow-x: hidden;
    overflow-y: auto;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-left: 4px;
    padding-bottom: 10px;
    align-items: center;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 100px;
    padding-bottom: 8px;
    //padding-top: 5px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 45px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 20px;
    display: flex;
}
.sub-info{
    width: calc(100% - 50px);
    color: #333333;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.status-info{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}
.status-info-fb{
    width: 50px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    flex-shrink: 0;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>